/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{position:absolute;top:0}.address-pick-wrap[_ngcontent-%COMP%]{background:#fff;padding:10px;box-shadow:1px 1px 10px #a1a1a1}.button-line[_ngcontent-%COMP%]{width:100%;text-align:center;margin-top:10px}\n/*# sourceMappingURL=stacked-addresses-pick.component.css.map*/"];
export { styles as styles };
